module.exports = __webpack_public_path__ + "img/menu_items.9a603708.svg";